import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initializeSession } from './lib/auth'
import './index.css'

// Kick off the session fetch at bootstrap (bench-E-095.CB-F point 9) — every screen's
// own auth gate awaits the same memoized promise, so this just warms the cache instead
// of making each screen pay for its own round trip.
void initializeSession()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch((err: unknown) => {
      console.warn('[SW] Registration failed:', err)
    })
  })
}
